import absoluteUrl from "next-absolute-url";
import {getAxiosInstance} from "src/server/utils/getAxiosInstance";
import * as ProductsApi from "src/core/api/products";
import {generateSiteMap} from "src/server/sitemaps";
import {getSiteInCluster} from "src/server/clusters";
import {ALL_PRODUCTS_DELIVERY_TYPE} from "src/server/constants";

const BrandsSitemap = () => {};

export const getServerSideProps = async ({res, req, query}) => {
  const {host} = absoluteUrl(req);
  const shop = query.shop;
  const axiosInstance = getAxiosInstance(shop, host);
  try {
    const data = await getAllBrandPaths(axiosInstance);
    const siteConfig = getSiteInCluster(host);
    const sitemap = await generateSiteMap({
      shop,
      host: siteConfig.canonicalDomain,
      data,
      siteMapName: "brands",
    });
    res.setHeader("Content-Type", "text/xml");
    res.write(sitemap);
    res.end();
  } catch (e) {
    console.error(e);
  }
  return {
    props: {},
  };
};

async function getAllBrandPaths(axiosInstance) {
  const {data: brands} = await ProductsApi.brands(
    {delivery_type: ALL_PRODUCTS_DELIVERY_TYPE},
    axiosInstance
  );
  return brands.map(brand => ({
    path: `/brands/${brand.attributes.slug}/`,
  }));
}

export default BrandsSitemap;
